/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ mode: NonNullable<unknown>, summary: NonNullable<unknown> }} Irrigation_Schedule_Status_ActiveInputs */

const vi_irrigation_schedule_status_active = /** @type {(inputs: Irrigation_Schedule_Status_ActiveInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Đang áp dụng: ${i?.mode} · ${i?.summary}`)
};

/**

* @param {Irrigation_Schedule_Status_ActiveInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const irrigation_schedule_status_active = /** @type {((inputs: Irrigation_Schedule_Status_ActiveInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Irrigation_Schedule_Status_ActiveInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_irrigation_schedule_status_active(inputs)
});